import { VideoMarkerOutlineIcon } from './VideoMarkerOutlineIcon';

/**
 * author: Simran
 * id D2C8C1CD-F565-4549-8030-8549512C6905
 * name video-marker-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-marker-outline.svg
 * tags
 * - Video / Movie 
 * - Navigation 
 */
export const VideoLocationOutlineIcon = VideoMarkerOutlineIcon;
export default VideoLocationOutlineIcon